import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import Swal from "sweetalert2";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import LogoCenter from "../components/LogoCenter";
import BlankSpace from "../components/BlankSpace";
import BottomNav from "../components/BottomNav";
import DrawerRight from "../components/DrawerRight";
import ScrollToDown from "components/scroll/ScrollToDown";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const serverId = process.env.REACT_APP_SERVER_ID;
const siteId = process.env.REACT_APP_SITE_ID;
const storeId = process.env.REACT_APP_STORE_ID;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;

export const RevenueCenterSL = (props) => {
  const history = useHistory();
  const [, setCookie] = useCookies([
    "firstName",
    "roomNumber",
    "customerId",
    "customerNumber",
    "customerDetails",
  ]);
  const [revenueCenters, setRevenueCenters] = useState([]);
  const [selectedRevenueCenter, setSelectedRevenueCenter] = useState("none");
  const [menus, setMenus] = useState([]);

  const urlParams = new URLSearchParams(props.location.search);
  const token = urlParams.get("token") ?? "";
  const customerNumberParam = urlParams.get("customer_number") ?? "";
  const firstNameParam = urlParams.get("first_name") ?? "";
  const roomNumberParam = urlParams.get("room_number") ?? "";

  useEffect(() => {
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Missing token.",
        icon: "error",
        confirmButtonText: "OK",
      });
      history.push("/");
      return;
    }

    const showError = (text) => {
      Swal.fire({
        title: "Error",
        text,
        icon: "error",
        confirmButtonText: "OK",
      });
      history.push("/");
    };

    const finalizeLogin = (customer) => {
      sessionStorage.setItem("customer", JSON.stringify(customer));
      sessionStorage.setItem("firstName", customer.FirstName);
      sessionStorage.setItem("lastName", customer.LastName);
      sessionStorage.setItem("isAdminLogin", 0);
      sessionStorage.setItem("roomNumber", customer.Address1);
      sessionStorage.setItem("servingPeriod", "none");
      sessionStorage.setItem("pinCodeOk", 1);
      sessionStorage.setItem("tokenLogin", 1);
      setCookie("firstName", customer.FirstName, { path: "/" });
      setCookie("roomNumber", customer.Address1, { path: "/" });
      setCookie("customerId", customer.CustomerID, { path: "/" });
      setCookie("customerNumber", customer.CustomerNumber, { path: "/" });
      setCookie("customerDetails", customer, { path: "/" });
    };

    const loginWithToken = (customerNumber) => {
      const url = `${apiBaseURL}/customer/login-customer-number-token/${serverId}/${siteId}/${token}/${customerNumber}`;
      return axios.get(url).then((response) => {
        if (response.data) {
          finalizeLogin(response.data);
        } else {
          showError("Invalid token or customer number.");
        }
      });
    };

    let loginPromise;
    if (customerNumberParam) {
      loginPromise = loginWithToken(customerNumberParam);
    } else if (firstNameParam && roomNumberParam) {
      const resolveUrl = `${apiBaseURL}/customer/login/${serverId}/${siteId}/${storeId}/${firstNameParam}/${roomNumberParam}`;
      loginPromise = axios.get(resolveUrl).then((response) => {
        const resolved = response.data;
        if (!resolved || !resolved.CustomerNumber) {
          showError("Invalid account details.");
          return;
        }
        return loginWithToken(resolved.CustomerNumber);
      });
    } else {
      showError("Missing customer details.");
      return;
    }

    loginPromise.catch(() => {
      showError("An error occurred while logging in.");
    });
  }, []);

  useEffect(() => {
    const url = `${apiBaseURL}/items/revenue-center/${serverId}/${siteId}`;
    axios
      .get(url)
      .then((response) => {
        setRevenueCenters(response.data ?? []);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (selectedRevenueCenter === "none") return;
    const url = `${apiBaseURL}/items/revenue-menu/${serverId}/${siteId}/${selectedRevenueCenter}`;
    axios
      .get(url)
      .then((response) => {
        const data = response.data;
        if (!data || data === "" || (Array.isArray(data) && data.length === 0)) {
          sessionStorage.setItem("revenueCenter", selectedRevenueCenter);
          sessionStorage.removeItem("selectedMenu");
          history.push("/menu");
          return;
        }
        if (Array.isArray(data) && data.length === 1) {
          sessionStorage.setItem("revenueCenter", selectedRevenueCenter);
          sessionStorage.setItem("selectedMenu", data[0].MenuName);
          history.push("/menu");
          return;
        }
        setMenus(data);
      })
      .catch(() => {});
  }, [selectedRevenueCenter]);

  const handleSelectRevenueCenter = (item) => {
    setSelectedRevenueCenter(item.RevenueName);
  };

  const handleSelectMenu = (item) => {
    sessionStorage.setItem("revenueCenter", selectedRevenueCenter);
    sessionStorage.setItem("selectedMenu", item.MenuName);
    history.push("/menu");
  };

  const handleBack = () => {
    setSelectedRevenueCenter("none");
    setMenus([]);
  };

  const showingMenus = selectedRevenueCenter !== "none" && menus.length > 0;

  return (
    <div className="Welcome">
      <LogoCenter />
      <BlankSpace />
      <DrawerRight />
      <Container fluid="md" className="welcomeCustom">
        {showingMenus && (
          <IconButton
            onClick={handleBack}
            id="nohover"
            disableautofocus
            disableenforcefocus
          >
            <ArrowBackIcon /> Back
          </IconButton>
        )}
        <Row>
          {showingMenus
            ? menus.map((item) => (
                <Col
                  xs={12}
                  sm={4}
                  className="blankspace center"
                  key={item.MenuName}
                >
                  <Card>
                    <CardActionArea onClick={() => handleSelectMenu(item)}>
                      <CardMedia
                        component="img"
                        height="140"
                        image={siteMedSrc + item.MenuName + ".webp"}
                        alt={item.MenuName}
                      />
                      <CardContent sx={{ paddingTop: 0 }}>
                        <Typography gutterBottom variant="h4" component="div">
                          {item.PeriodName ||
                            item.ServingPeriodName ||
                            item.MenuName}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Col>
              ))
            : revenueCenters.map((item) => (
                <Col
                  xs={12}
                  sm={4}
                  className="blankspace center"
                  key={item.RevenueName}
                >
                  <Card>
                    <CardActionArea
                      onClick={() => handleSelectRevenueCenter(item)}
                    >
                      <CardMedia
                        component="img"
                        height="140"
                        image={siteMedSrc + item.RevenueName + ".webp"}
                        alt={item.RevenueName}
                      />
                      <CardContent sx={{ paddingTop: 0 }}>
                        <Typography gutterBottom variant="h4" component="div">
                          {item.RevenueName}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Col>
              ))}
        </Row>
      </Container>
      <BlankSpace />
      <BlankSpace />
      <BottomNav sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} />
      <ScrollToDown />
    </div>
  );
};
